<div class="auditItem Data-Change-Category">
  <div class="auditIconWrap">
    <div class="auditBadgeIcon"></div>
    <div class="auditIcon" title="DataChange"></div>
  </div>
  <div class="auditInfo">
    <div class="auditHeader"><span class="auditTimestamp">{{dataChange?.updated |  formatDateWithTimezone | async}}</span> <span
        (click)="isSelected ? unselected.emit() : selected.emit()" class="showAuditDetails">
        <mat-icon>info</mat-icon>
      </span></div>
    <div class="auditDescription">
      <p>
        <!-- testo iniziale -->
        <ng-container [ngSwitch]="dataChange?.operation.toLowerCase()">
          <span *ngSwitchCase="'add'"><strong>Aggiunto </strong> </span>
          <span *ngSwitchCase="'update'"><strong>Aggiornato </strong> </span>
          <span *ngSwitchCase="'delete'"><strong>Eliminato </strong> </span>
        </ng-container>
        <!-- tipo di elemento -->
        <ng-container [ngSwitch]="dataChange?.entity.toLowerCase()">
          <span *ngSwitchCase="'partitaiva'">il campo <span class="fieldLabel">Partita iva </span> </span>
          <span *ngSwitchCase="'phonenumber'">un <strong>numero di telefono </strong> </span>
          <span *ngSwitchCase="'businesssector'">il <strong>settore merceologico </strong> </span>
          <span *ngSwitchCase="'rawvalue'">{{dataChange?.operation.toLowerCase() == 'delete' ? 'dalle' : 'nelle'}}
            informazioni acquisite il campo </span>
          <span *ngSwitchDefault>il campo <span class="fieldLabel">{{dataChange?.entity}} </span> </span>
        </ng-container>

        <!-- esposizone dei dati -->
        <ng-container [ngSwitch]="dataChange?.operation.toLowerCase()">
          <span *ngSwitchCase="'add'" [ngTemplateOutlet]="add"></span>
          <span *ngSwitchCase="'update'" [ngTemplateOutlet]="update"></span>
          <span *ngSwitchCase="'delete'" [ngTemplateOutlet]="delete"></span>
        </ng-container>
      </p>




    </div>
    <div class="auditCommentWrap">

      <div class="auditCommentText">
        <p>
          {{dataChange?.comment}}
        </p>
      </div>
    </div>
  </div>
</div>


<ng-template #add>
  <ng-container [ngSwitch]="dataChange?.entity.toLowerCase()">

    <span *ngSwitchCase="'comune'">
      <strong>{{dataChange?.newData.nome}} ({{dataChange?.newData.provincia?.sigla}})</strong>
    </span>
    <span *ngSwitchCase="'provincia'">
      <strong> {{dataChange?.newData.nome}} ({{dataChange?.newData.sigla}})</strong>
    </span>
    <span *ngSwitchCase="'businesssector'">
      <strong>{{dataChange?.newData.description}} ({{dataChange?.newData.atecoCode}})</strong>
    </span>
    <span *ngSwitchDefault>
      <span
        class="fieldLabel">{{dataChange?.newData?.name ? dataChange?.newData.name : dataChange?.newData.description}}</span>
      <strong> {{dataChange?.newData?.value}}</strong>
    </span>
  </ng-container>

</ng-template>

<ng-template #update>
  <ng-container [ngSwitch]="dataChange?.entity.toLowerCase()">
    <span *ngSwitchCase="'comune'">
      {{dataChange?.oldData.nome}} ({{dataChange?.oldData.provincia?.sigla}}) &rarr;
      <strong>{{dataChange?.newData.nome}}
        ({{dataChange?.newData.provincia?.sigla}})</strong>
    </span>
    <span *ngSwitchCase="'provincia'">
      {{dataChange?.oldData.nome}} ({{dataChange?.oldData.sigla}}) &rarr; <strong>{{dataChange?.newData.nome}}
        ({{dataChange?.newData.sigla}})</strong>
    </span>
    <span *ngSwitchCase="'businesssector'">
      {{dataChange?.oldData.description}} ({{dataChange?.oldData.atecoCode}}) &rarr;
      <strong>{{dataChange?.newData.description}} ({{dataChange?.newData.atecoCode}})</strong>
    </span>
    <span *ngSwitchDefault>
      <span
        class="fieldLabel">{{dataChange?.oldData?.name ? dataChange?.oldData.name : dataChange?.oldData.description}}</span>
      {{dataChange?.oldData?.value}} &rarr; <strong>{{dataChange?.newData?.value}}</strong>
    </span>
  </ng-container>
</ng-template>

<ng-template #delete>
  <ng-container [ngSwitch]="dataChange?.entity.toLowerCase()">
    <span *ngSwitchCase="'comune'">
      {{dataChange?.oldData?.nome}} ({{dataChange?.oldData.provincia?.sigla}})
    </span>
    <span *ngSwitchCase="'provincia'">
      {{dataChange?.oldData.nome}} ({{dataChange?.oldData.sigla}})
    </span>
    <span *ngSwitchCase="'businesssector'">
      <strong>{{dataChange?.oldData.description}} ({{dataChange?.oldData.atecoCode}})</strong>
    </span>
    <span *ngSwitchDefault>
      <span
        class="fieldLabel">{{dataChange?.oldData?.name ? dataChange?.oldData?.name : dataChange?.oldData.description}}</span>
      <strong> {{dataChange?.oldData?.value}}</strong>
    </span>
  </ng-container>
</ng-template>
